import { InputProps, SelectInput } from "react-admin"

import { DocumentTypeChoices } from "../../billing_constants"

export const DocumentTypeSelectInput: React.FC<InputProps> = (props) => (
  <SelectInput {...props} choices={DocumentTypeChoices} />
)
